import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { CustomerPortalSustainabilityReportingResponse } from './endpoints/CustomerPortalSustainabilityReportingEndpoint.types';

export type CustomerPortalSustainabilityReporting = CustomerPortalSustainabilityReportingResponse;

export async function fetchCustomerPortalSustainabilityReporting(args: {
  customerId: number;
  startDate: string;
  endDate: string;
}): Promise<CustomerPortalSustainabilityReporting> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());
  searchParams.append('startDate', args.startDate);
  searchParams.append('endDate', args.endDate);

  return fetchEndpointData<CustomerPortalSustainabilityReportingResponse>(
    `/api/customer-portal/sustainability-reporting?${searchParams.toString()}`,
    {
      method: 'GET',
    },
  );
}
